export default __webpack_public_path__ + "static/logo_react-18013cbd341773bd71c2587a1504f0fe.png";